export default __webpack_public_path__ + "static/media/44.e0f3783f.svg";